import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import { PoweredBy } from "@/components/PoweredBy";
import { BRAND } from "@/lib/brand";
import { BrandMark, useBrand } from "@/lib/branding";

export function AuthLayout({ title, subtitle, children }: { title: string; subtitle: string; children: ReactNode }) {
  const brand = useBrand();
  return (
    <div className="grid min-h-full lg:grid-cols-2">
      <aside className="hidden flex-col justify-between bg-gradient-to-br from-brand-strong via-brand to-accent p-12 text-white lg:flex">
        <div className="flex items-center gap-3">
          {brand.logo_url ? <img src={brand.logo_url} alt={brand.name} className="h-10 rounded-lg bg-white/95 p-1" /> : <>
            <BrandMark className="h-10 w-10" onDark />
            <span className="text-xl font-semibold tracking-tight">{brand.name}</span></>}
        </div>
        <div>
          <p className="text-3xl font-semibold leading-tight">{BRAND.pitch}</p>
          <p className="mt-4 max-w-md text-white/85">
            Inquiries, quotes, orders, WhatsApp and service in one place, connected to the tools you already use.
          </p>
        </div>
        <div className="flex items-center justify-between text-sm text-white/70">
          <span>© {new Date().getFullYear()} {brand.name}</span>
          <PoweredBy onDark />
        </div>
      </aside>
      <main className="flex flex-col items-center justify-center p-6">
        <div className="w-full max-w-md">
          <div className="mb-8 flex items-center gap-2 lg:hidden">
            <BrandMark />
            <span className="text-lg font-semibold">{brand.name}</span>
          </div>
          <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
          <p className="mb-8 mt-1 text-sm text-muted">{subtitle}</p>
          {children}
          <p className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-muted">
            <Link to="/legal/terms" className="hover:text-brand">Terms</Link>
            <Link to="/legal/privacy" className="hover:text-brand">Privacy</Link>
            <Link to="/status" className="hover:text-brand">System status</Link>
          </p>
          <div className="mt-4 flex justify-center lg:hidden"><PoweredBy /></div>
        </div>
      </main>
    </div>
  );
}
